import { Button } from 'antd';
import styled from 'styled-components';

export const FullscreenButton = styled(Button)`
  height: 3.2rem;
  width: 3.2rem;
  padding: 0;
  font-size: 2rem;
`;
